import { Component, OnInit, Input } from '@angular/core';

import { InvestOutput } from '@classes/invest/invest-bbc/invest-output';

@Component({
    selector: 'app-overview-datatable',
    templateUrl: './overview-datatable.component.html',
    styleUrls: ['./overview-datatable.component.scss']
})
export class OverviewDatatableComponent implements OnInit {
    @Input() overview: InvestOutput;

    constructor( ) { }

    ngOnInit() {
    }
}
